import { APPCUES_ACCOUNT_ID, APPCUES_GET_EVENT, endPoints } from "./urls";

export const fetchAppcuesEvents = async (user_Id:any) => {
    const url = `${APPCUES_GET_EVENT}/${APPCUES_ACCOUNT_ID}/${endPoints.USERS}/${user_Id}/${endPoints.EVENTS}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': 'Basic YTRkMzllMzctNGUwMC00YTc4LWE2YWItNGQyZmE2MWIzMGYyLTAyOmVlMjU4ZDI0LTYzNzMtNDcwZi1iN2UwLTcxYTIxZTFjMTBmMw==',
          'Content-Type': 'application/json',
        },
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const data = await response.json();
      console.log('Appcues events:', data);
      return data;
    } catch (error) {
      console.error('Failed to fetch Appcues events:', error);
    }
  };
  